import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type { GetUserResT } from 'server/controllers';
import type * as SSNS from 'server/services/user';

import { P_API_USERS, type UserT } from 'utils';

const ss = webpack.requireWeak<typeof SSNS>(
  'server/services/user',
  import.meta.dirname,
);

export async function getUser(
  id: string,
): Promise<UserT> {
  if (ss) {
    const res = await ss.getUser(id);
    if (!res) throw Error('User not found');
    return res;
  }

  const res = await axios<GetUserResT>(`${P_API_USERS}/${id}`);

  return res.data;
}
